import { Component, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { AdminStammdatenLandEntryComponent } from '@app/admin/stammdaten/land/admin-stammdaten-land-entry/admin-stammdaten-land-entry.component';
import { AdminStammdatenLandNewComponent } from '@app/admin/stammdaten/land/admin-stammdaten-land-new/admin-stammdaten-land-new.component';
import { BackendService } from '@app/shared/services/backend.service';
import { TranslatePipe } from '@ngx-translate/core';
import { rxResource } from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-admin-stammdaten-land',
  templateUrl: './admin-stammdaten-land.component.html',
  imports: [
    AdminStammdatenLandNewComponent,
    MatTooltip,
    TranslatePipe,
    AdminStammdatenLandEntryComponent,
  ],
})
export class AdminStammdatenLandComponent {
  private readonly backendService = inject(BackendService);

  protected readonly laender = rxResource({ defaultValue: [], stream: () => this.backendService.listLaender() });

  onLandDeleted(id: number) {
    this.laender.update( list =>
      list.filter( land => land.id !== id )
    );
  }
}
